import axios from 'axios';

/** Устаревший/чужой cursor требует сброса страниц, а не повтора продолжения. */
export const isAnalyticsInsightCursorError = (error: unknown): boolean => {
  if (axios.isAxiosError(error))
    return (
      error.response?.status === 400 &&
      error.response?.data?.detail === 'Invalid or foreign analytics cursor'
    );
  return (
    error instanceof Error &&
    'status' in error &&
    error.status === 400 &&
    error.message === 'Invalid cursor'
  );
};

/** CAS-конфликт требует перечитать состояние перед новым решением пользователя. */
export const isAnalyticsInsightStateConflict = (error: unknown): boolean => {
  if (axios.isAxiosError(error))
    return (
      error.response?.status === 409 &&
      error.response?.data?.detail?.code === 'insight-user-state-conflict'
    );
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    error.code === 'insight-user-state-conflict'
  );
};

/** Безопасное объяснение ошибки контракта инсайтов без сырого ответа сервера. */
export const analyticsInsightErrorMessage = (error: unknown): string => {
  if (isAnalyticsInsightStateConflict(error))
    return 'Отметка или отзыв уже изменились в другой вкладке. Обновите состояние и проверьте его перед повторным сохранением.';
  const status = axios.isAxiosError(error)
    ? error.response?.status
    : typeof error === 'object' && error !== null && 'status' in error
      ? error.status
      : undefined;
  switch (status) {
    case 401:
      return 'Требуется авторизация. Войдите в приложение повторно.';
    case 400:
      return 'Параметры запроса устарели или неверны. Обновите список.';
    case 403:
      return 'Недостаточно прав для этого действия.';
    case 404:
      return 'Инсайт или связанный ресурс недоступен.';
    case 409:
      return 'Команда уже использована с другими параметрами. Проверьте данные задачи.';
    case 422:
      return 'Некорректные параметры. Проверьте поля формы или выбранные фильтры.';
    case 503:
      return 'Сервис временно недоступен. Повторите попытку позже.';
    default:
      return 'Не удалось выполнить действие. Попробуйте ещё раз.';
  }
};
